<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1>Elenco comunicazioni</h1>

    <div class="row justify-content-between mx-2 mt-5 mb-2 align-middle">
      <h4>Elenco comunicazioni</h4>
    </div>

    <!-- ---------------------------- -->
    <b-tabs
      v-model="tabIndex"
      @input="selectTab"
    >
      <b-tab
        title="Da leggere"
        active
      ></b-tab>
      <b-tab title="Lette"></b-tab>
      <b-tab title="Archiviate"></b-tab>
    </b-tabs>

    <loading-spinner v-if="loading" />
    <template v-else>
      <b-alert
        v-if="!loading && !items.length"
        show
        variant="info"
        class="my-4"
      >
        <!-- <template v-if="!selectedTab"> -->
        <template>
          Non ci sono notifiche nello storico.
        </template>
      </b-alert>

      <b-table
        v-if="items.length"
        striped
        bordered
        hover
        :fields="fields"
        :items="items"
        :responsive="true"
        :busy="false"
        @row-clicked="onRowClicked"
      >

        <template v-slot:cell(oggetto)="data">
          <div class="text-left">
            {{data.item[data.field.key]}}
          </div>
        </template>

        <template v-slot:cell(timeStampCreazione)="data">
          {{formatDateTime(data.item[data.field.key])}}
        </template>

        <template v-slot:cell(timeStampVista)="data">
          {{formatDateTime(data.item[data.field.key])}}
        </template>

        <template v-slot:cell(timeStampLettura)="data">
          {{formatDateTime(data.item[data.field.key])}}
        </template>

        <template v-slot:head(download)>
          <font-awesome-icon
            icon="file-alt"
            size="lg"
            class="text-muted"
          />
        </template>

      </b-table>

      <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
        <div class="text-right">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </div>
        <div class="text-right">
          <b-form-group
            description="Per pagina"
            class="mb-0"
          >
            <b-form-select
              :options="pageOptions"
              v-model="perPage"
            />
          </b-form-group>
        </div>
      </div>
    </template>

    <!-- ----------------------------- -->

  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  data () {
    return {
      items: [],
      fields: [
        { key: 'idNotifica', label: 'id', sortable: true },
        { key: 'sezioneRiferimento', label: 'Sezione', sortable: true },
        { key: 'oggetto', label: 'Comunicazione', sortable: true },
        { key: 'timeStampCreazione', label: 'Creazione', sortable: true },
        { key: 'timeStampVista', label: 'Notifica', sortable: true },
        { key: 'timeStampLettura', label: 'Lettura', sortable: true },
        { key: 'letto', label: 'Letta', sortable: true, formatter: (value) => { return value ? 'Si' : 'No' } },
        { key: 'eliminato', label: 'Archiviata', sortable: true, formatter: (value) => { return value ? 'Si' : 'No' } },
        'download'
      ],
      loading: true,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15],
      tabIndex: 0
    }
  },

  async created () {
    await this.load()
  },

  methods: {

    back () {
      this.$router.push({ name: 'home' })
    },

    async load () {
      try {
        this.loading = true

        let criterio = ''
        if (this.tabIndex === 0) {
          criterio = 'daLeggere'
        } else if (this.tabIndex === 1) {
          criterio = 'lette'
        } else if (this.tabIndex === 2) {
          criterio = 'archiviate'
        }

        // console.log('Load tab ', criterio)

        // await this.$store.dispatch({ name: 'messages/loadItems', params: { criterio: criterio } })
        await this.$store.dispatch('messages/loadItems', criterio)

        // console.log(this.$store)
        this.items = this.$store.state.messages.items
        this.totalRows = this.items.length || 0
        // console.log('this.totalRows', this.items, this.totalRows)

      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },
    onRowClicked (row) {
      this.$router.push({ name: 'message', params: { id: row.id } })
    },

    urlComunicazione (id) {
      return `/api/messages/${id}/download`
    },
    async selectTab (tab) {
      // console.log('selectTab', tab)
      await this.load()
      this.tabIndex = tab
    },
    formatDateTime (dateStr) {
      return dateStr ? moment(dateStr).format('DD/MM/YYYY HH:mm') : ''
    }

  }
}
</script>

<style lang="stylus" scoped>
.dateWidth {
  width: 300px;
}
</style>
